import React from 'react'

const TextHighlight = ({highlight, children, pointer, boldValue, fontSize="16px", style={}}) => {
    
    const highlightColor = () => {
        if(highlight=="red") return ({background:"red", textColor:"white"})
        if(highlight=="yellow")return ({background:"#FFBF00", textColor:"white"})
        if(highlight=="green") return ({background:"green", textColor:"white"})
        if(highlight=="blue") return ({background:"blue", textColor:"white"})
        if(highlight=="darkRed") return ({background:"#8B0000", textColor:"white"})
        if(highlight=="amber") return ({background:"#ff8503", textColor:"white"})
        if(highlight=="none") return ({textColor:"#324d67", border: "1px solid #324d67"})
      }
       
      const highlightStyle = {
          backgroundColor: highlightColor()?.background && highlightColor()?.background, 
          color:highlight && highlightColor()?.textColor, 
          padding:"4px", 
          paddingLeft:"5px", 
          paddingRight:"5px", 
          borderRadius:"4px",
          fontSize: fontSize,
          border: highlightColor()?.border && highlightColor()?.border, 
          cursor: pointer && "pointer",
         

          ...style
      }
  return (
    <>
    {!boldValue ?
    <span style={highlight && highlightStyle}>
        {children}
    </span> :
    <h3 style={highlight && highlightStyle}>
      {children}
    </h3> 
  }
  </>
  )
}

export default TextHighlight
